export default __webpack_public_path__ + "static/lframe-loans-4fc86a3d40618aafae8ba275a14802bf.webp";